/* eslint-disable react/jsx-pascal-case */
import React from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Outlet,
} from "react-router-dom";
import { ToastContainer } from "react-toastify";

// Layout Components
import Layout from "./component/Layout"; // Create this file (see step 2)
import PrivateRoutes from "./component/PrivateRoute";

// Page Imports (Keep your existing imports)
import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import AddInvestor from "./Investor_Pool/AddInvestor";
import InvestorsList from "./Investor_Pool/InvestorsList";
import AddMentor from "./pages/mentor/Add_Mentor";
import MentorList from "./pages/mentor/Mentor_list";
import AddTemplate from "./pages/template/AddTemplate";
import AddCategory from "./pages/template/AddCategory";
import TemplateList from "./pages/template/TemplateList";
import AddCourses from "./pages/courses/AddCourses";
import AddModule from "./pages/courses/AddModule";
import UploadVideo from "./pages/courses/UploadVideo";
import AddPartner from "./pages/partners/AddPartner";
import Add_ca from "./pages/CA/Add_CA";
import Add_tech_company from "./pages/TechCompanies/AddTechCompany";
import Startups from "./pages/Startup/Startup";
import StartupDetailPage from "./pages/Startup/StartupDetailPage";
import Leads from "./pages/leads/Leads";
import AddLead from "./pages/leads/AddLead";
import LeadViewPage from "./pages/leads/LeadViewPage";
import LeadDashboard from "./pages/leads/LeadDashboard";
import InquiryViewPage from "./pages/leads/InquiryViewPage";
import Inquiries from "./pages/leads/Inquiries";
import AddIncubation from "./pages/incubation/AddIncubationCenter";
import ListIncubation from "./pages/incubation/ListIncubationCenter";
import EditIncubation from "./pages/incubation/EditIncubationCenter"

import BulkMessage from "./pages/whatsapp/BulkMessage";
function App() {
  return (
    <Router>
      <ToastContainer theme="colored" />
      <Routes>
        {/* Public Route */}
        <Route path="/" element={<Login />} />

        {/* Private Routes wrapped in Layout */}
        <Route element={<PrivateRoutes />}>
          <Route
            element={
              <Layout>
                <Outlet />
              </Layout>
            }
          >
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/addinvestor" element={<AddInvestor />} />
            <Route path="/investorlist" element={<InvestorsList />} />
            <Route path="/incubation/add" element={<AddIncubation />} />
            <Route path="/incubation/list" element={<ListIncubation />} />
            <Route path="/incubation/edit/:id" element={<EditIncubation />} />
            <Route path="/add-mentor" element={<AddMentor />} />
            <Route path="/add-ca" element={<Add_ca />} />
            <Route path="/add-tech-company" element={<Add_tech_company />} />
            <Route path="/mentor-list" element={<MentorList />} />
            <Route path="/add-course" element={<AddCourses />} />
            <Route path="/add-module" element={<AddModule />} />
            <Route path="/upload-video" element={<UploadVideo />} />
            <Route path="/add-template" element={<AddTemplate />} />
            <Route path="/add-category" element={<AddCategory />} />
            <Route path="/template-list" element={<TemplateList />} />
            <Route path="/add-partner" element={<AddPartner />} />
            <Route path="/startups" element={<Startups />} />
            <Route
              path="/startup_detail/:startupId"
              element={<StartupDetailPage />}
            />
            <Route path="/add-lead" element={<AddLead />} />
            <Route path="/leads" element={<Leads />} />
            <Route path="/inquiries" element={<Inquiries />} />
            <Route path="/lead/:leadId" element={<LeadViewPage />} />
            <Route path="/inquiry/:inquiryId" element={<InquiryViewPage />} />
            <Route path="/lead-dashboard" element={<LeadDashboard />} />
            <Route path="/bulk-message" element={<BulkMessage />} />
          </Route>
        </Route>
      </Routes>
    </Router>
  );
}

export default App;
